import React, { useEffect, useState } from "react";
import { api, isManagedFile, absoluteFileUrl } from "@/api/client";

// Displays an image. For backend-managed uploads (/api/files/...) it fetches a
// short-lived token so the <img> can authenticate; absolute URLs render directly.
export function AuthImage({ src, alt = "", className, style, fallback = null, ...rest }) {
  const [resolved, setResolved] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setFailed(false);
    if (!src) {
      setResolved(null);
      return;
    }
    if (!isManagedFile(src)) {
      setResolved(absoluteFileUrl(src));
      return;
    }
    // Extract the storage path after /api/files/
    const path = src.split("/api/files/")[1]?.split("?")[0];
    (async () => {
      try {
        const { token } = await api.fileToken(decodeURIComponent(path));
        if (!active) return;
        setResolved(`${absoluteFileUrl(src)}?token=${encodeURIComponent(token)}`);
      } catch {
        if (active) setFailed(true);
      }
    })();
    return () => {
      active = false;
    };
  }, [src]);

  if (failed || !src) {
    return (
      fallback || (
        <div
          className={className}
          style={{ ...style, background: "var(--surface-2)" }}
          data-testid="image-fallback"
        />
      )
    );
  }
  if (!resolved) {
    return <div className={className} style={{ ...style, background: "var(--surface-2)" }} />;
  }
  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      style={style}
      onError={() => setFailed(true)}
      {...rest}
    />
  );
}
